import BaseApi from './BaseApi';

class PartnersRegistrationApi extends BaseApi {
  constructor(config) {
    super(config);
    this.endpoint = config?.endpoint ?? '/evaluations/api/v1/partners/accounts';
  }

  async create(body) {
    const url = `${this.baseUrl}${this.endpoint}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    return this.parseResponse(response);
  }
}

export default PartnersRegistrationApi;
